import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-number-type',
  template: `
    <div class="field p-fluid mb-3 mt-1">
      <div class="pt-2">
        <p-inputNumber
          [formControl]="formControl"
          [formlyAttributes]="field"
          [min]="field.templateOptions.min"
          [max]="field.templateOptions.max"
          [maxFractionDigits]="
            field.props?.attributes?.['maxFractionDigits']
              ? +field.props?.attributes?.['maxFractionDigits']
              : 3
          "
          [minFractionDigits]="
            field.props?.attributes?.['minFractionDigits']
              ? +field.props?.attributes?.['minFractionDigits']
              : 1
          "
          [step]="
            field.props?.attributes?.['step']
              ? +field.props?.attributes?.['step']
              : null
          "
        ></p-inputNumber>
      </div>

      <div
        *ngIf="showError && formControl.errors"
        class="text-sm mt-2 p-error"
      >
        <formly-validation-message
          [field]="field"
        ></formly-validation-message>
      </div>

      <div
        *ngIf="
          field.templateOptions.description &&
          (!showError || !formControl.errors)
        "
        class="text-sm mt-2"
      >
        {{ field.templateOptions.description }}
      </div>
    </div>
  `,
})
export class NumberTypeComponent extends FieldType<FieldTypeConfig> {}
